import { useAsyncAction } from "@/lib/hooks/use-async-action";

// Placeholder for profile update mutations
// This would be extended when we have actual profile update GraphQL mutations
export const useUpdateProfile = () => {
  return useAsyncAction(
    async (_input: { firstName?: string; lastName?: string; email?: string }) => {
      return Promise.resolve();
    },
    {
      loadingMessage: "Updating profile...",
      successMessage: "Profile updated successfully!",
      errorMessage: "Failed to update profile",
    }
  );
};

export const useUpdateNotificationPreferences = () => {
  return useAsyncAction(
    async (_preferences: { browserNotifications?: boolean }) => {
      return Promise.resolve();
    },
    {
      loadingMessage: "Updating notification preferences...",
      successMessage: "Notification preferences updated!",
      errorMessage: "Failed to update notification preferences",
    }
  );
};
